export const API_USER = "Login/Verify"


export const SUCCESS_GET_LOGIN = 'SUCCESS_GET_LOGIN'
export const FAILED_GET_LOGIN = 'FAILED_GET_LOGIN'
export const ERROR_GET_LOGIN = 'ERROR_GET_LOGIN'

export const SUCCESS_GET_HEADER = 'SUCCESS_GET_HEADER'
export const FAILED_GET_HEADER = 'FAILED_GET_HEADER'
export const ERROR_GET_HEADER = 'ERROR_GET_HEADER'

export const SUCCESS_GET_VERIFICAR = 'SUCCESS_GET_VERIFICAR'
export const FAILED_GET_VERIFICAR = 'FAILED_GET_VERIFICAR'
export const ERROR_GET_VERIFICAR = 'ERROR_GET_VERIFICAR'


export const SUCCESS_SET_COMERCIOS = 'SUCCESS_SET_COMERCIOS'
export const FAILED_SET_COMERCIOS = 'FAILED_SET_COMERCIOS'
export const ERROR_SET_COMERCIOS = 'ERROR_SET_COMERCIOS'


export const TRANSACCIONES_DISPONIBLES = 1
export const TRANSACCIONES_SELECCIONADAS = 2


export const SUCCESS_LOGOUT = 'SUCCESS_LOGOUT'
export const FAILED_LOGOUT = 'FAILED_LOGOUT'
export const ERROR_LOGOUT = 'ERROR_LOGOUT'

export const SESSION_CONFIG = {
    TIME_INACTIVE_IN_MS: parseInt(process.env.REACT_APP_SESSION_TIME_INACTIVE_IN_MS),
    SESSION_TIMEOUT_IN_MS: parseInt(process.env.REACT_APP_SESSION_TIMEOUT_IN_MS)
};
export const SUCCESS_REFRESH_TOKEN ='SUCCESS_REFRESH_TOKEN'
export const FAILED_REFRESH_TOKEN = 'FAILED_REFRESH_TOKEN'
export const ERROR_REFRESH_TOKEN = 'ERROR_REFRESH_TOKEN'

export const RECAPTCHA_ACTION_LOGIN = 'LOGIN'
export const RECAPTCHA_ACTION_PASSWORD_RESET = 'PASSWORD_RESET'